import { Box } from '@chakra-ui/react';
import { Text, TextField } from '@diamond/shared/ui';
import { useFormContext } from 'react-hook-form';

import type { FormValues } from '../../types';

export function TitleField() {
  const {
    register,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <Box>
      <Text as="b" id="title-label">
        Judul Highlight
      </Text>
      <TextField
        name="title"
        label=""
        placeholder="contoh: Diamond"
        register={register}
        errors={errors}
        isRequired
        aria-labelledby="title-label"
      />
    </Box>
  );
}
